export enum QueryStatus {
  LOADING = 'loading',
  SUCCESS = 'success',
  IDLE = 'idle',
  ERROR = 'error'
}
